(() => {
  if (window.nxtSiteCleanupLoaded) return;
  window.nxtSiteCleanupLoaded = true;
  let observer;
  function init() {
    const marker = document.querySelector('[data-nxt-site-cleanup]');
    if (!marker) return;
    document.body.classList.add('nxt-site-cleanup');
    document.body.classList.toggle('nxt-widget-safe', marker.dataset.widgetSafeSpace === 'true');
    document.querySelectorAll('[data-nxt-apparel-info]').forEach(node => node.classList.add('nxt-apparel-pdp'));
    if (typeof IntersectionObserver !== 'function') return;
    observer?.disconnect();
    const visible = new Set();
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
      document.body.classList.toggle('nxt-purchase-zone', visible.size > 0);
    }, { rootMargin: '20px 0px', threshold: 0 });
    document.querySelectorAll('.product-information .product-form-buttons, .product-information .variant-picker, .nxt-custom-purchase .easify-product-options').forEach(node => observer.observe(node));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
